import { render, staticRenderFns } from "./prospectCollegeAssign.vue?vue&type=template&id=e7c138bc&scoped=true"
import script from "./prospectCollegeAssign.vue?vue&type=script&lang=js"
export * from "./prospectCollegeAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c138bc",
  null
  
)

export default component.exports